import { render, staticRenderFns } from "./VPaymentError.vue?vue&type=template&id=325a40ed&scoped=true&"
import script from "./VPaymentError.vue?vue&type=script&lang=js&"
export * from "./VPaymentError.vue?vue&type=script&lang=js&"
import style0 from "./VPaymentError.vue?vue&type=style&index=0&id=325a40ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325a40ed",
  null
  
)

export default component.exports